/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import moment from 'moment';
import {
  FilterOptionModel,
  JsonPatch,
  ProductionProcessDto,
  SelectInputListItem,
  inputFormType,
} from './models';
import { ZipDto } from './models/customerMaster.model';
import { showUploadRejections, validateUploadFiles } from './fileUpload';

export const randomDate = (start: Date, end: Date) => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
};

export const getISODateFormat = (
  selectedDate: Date | string,
  formate: string = 'MM-DD-YYYY'
) => {
  return selectedDate === null ||
    selectedDate === '' ||
    selectedDate === undefined
    ? ''
    : moment(selectedDate)?.format(formate)?.split('T')[0];
};

export const getISODateFormatWithUTCConversion = (
  selectedDate: Date | string,
  formate: string = 'MM-DD-YYYY'
) => {
  return selectedDate === null || selectedDate === ''
    ? ''
    : moment.utc(selectedDate)?.local()?.format(formate)?.split('T')[0];
};
export const SCHEDULE_HOLD_REASON_THRESHOLD_MONTHS = 1;

export const isScheduleHoldReasonRequired = (
  dueDate: string | Date | null | undefined
): boolean => {
  if (!dueDate) return false;
  return moment(dueDate).isAfter(
    moment().add(SCHEDULE_HOLD_REASON_THRESHOLD_MONTHS, 'month')
  );
};

export const getSuggestedScheduleHoldReasonText = (
  dueDate: string | Date
): string => {
  const suggestedDate = moment(dueDate).subtract(
    SCHEDULE_HOLD_REASON_THRESHOLD_MONTHS,
    'month'
  );
  return `Schedule on ${getISODateFormat(suggestedDate.toDate())}`;
};

export const getISOTimeFormatWithoutUTC = (
  selectedDate: Date | string,
  formate: string = 'hh:mm:ss A'
) => {
  return selectedDate === null || selectedDate === ''
    ? ''
    : moment(selectedDate)?.format(formate);
};

export const getISOTimeFormat = (
  selectedDate: Date | string,
  formate: string = 'hh:mm:ss A'
) => {
  return selectedDate === null || selectedDate === ''
    ? ''
    : moment.utc(selectedDate)?.local()?.format(formate);
};
export const getISODateAndTimeFormat = (
  selectedDate: Date | string,
  format = 'YYYY-MM-DDTHH:mm:ss'
) => {
  if (selectedDate === null || selectedDate === '') {
    return '';
  }

  try {
    const momentObject = moment.utc(selectedDate)?.local().format(format);

    // Remove trailing "Z" to exclude explicit UTC indicator
    return momentObject;
  } catch (error) {
    console.error('Error formatting date/time:', error);
    return ''; // Or return a default value like "Invalid Date"
  }
};

export const getIncrementDate = (date: string, day: number) => {
  return moment(date, 'YYYY-MM-DD').add(day, 'days').format('YYYY-MM-DD');
};
export const getDecrementDate = (date: string, day: number) => {
  return moment(date, 'YYYY-MM-DD').subtract(day, 'days').format('YYYY-MM-DD');
};

export const randomXToY = (minVal: number, maxVal: number) => {
  var randVal = minVal + Math.random() * (maxVal - minVal);
  return Math.round(randVal);
};

export const prepareQueryParams = (params: any) => {
  var queryString = Object.keys(params)
    .map((key: any) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    })
    .join('&');
  return queryString;
};

export const prepareFilterOptionModel = ({
  pageNumber = 1,
  pageSize = 100,
  fields = '',
  searchQuery = '',
  orderBy = '',
}: FilterOptionModel) => {
  const filterOptionModel = {
    pageNumber: pageNumber,
    pageSize: pageSize,
    fields: fields,
    searchQuery: searchQuery,
    orderBy: orderBy,
  };
  return filterOptionModel;
};

export const prepareListDataForSelectInput = (
  list: Array<any>,
  labelKey: string,
  valueKey: string,
  additionalKey?: string
) => {
  return list?.map((item: any) => {
    let obj: SelectInputListItem = {
      label: item[labelKey] + (additionalKey ? ' ' + item[additionalKey] : ''),
      value: item[valueKey],
    };
    return obj;
  });
};

export const prepareListDataForSelectInputProductionScreen = (
  list: Array<any>,
  labelKey: string,
  valueKey: string,
  groupWeek: string
) => {
  return list?.map((item: any) => {
    let obj: any = {
      label: item[labelKey],
      value: item[valueKey],
      groupWeek: item[groupWeek],
    };
    return obj;
  });
};

export const prepareListDataForSelectInputPart = (
  list: Array<any>,
  labelKey: string,
  valueKey: string,
  partNumber: string,
  gallopPartNumber: string
) => {
  return list?.map((item: any) => {
    let obj: any = {
      label: item[labelKey],
      value: item[valueKey],
      partNumber: item[partNumber],
      gallopPartNumber: item[gallopPartNumber] || item[partNumber],
    };
    return obj;
  });
};

export const prepareListDataForSelectInputComponent = (
  list: Array<any>,
  labelKey: string,
  valueKey: string,
  componentNumber: string
) => {
  return list?.map((item: any) => {
    let obj: any = {
      label: item[labelKey],
      value: item[valueKey],
      componentNumber: item[componentNumber],
    };
    return obj;
  });
};

export const prepareListDataForSelectInputSubPartMakeup = (
  list: Array<any>,
  labelKey: string,
  valueKey: string,
  partId: string,
  orderItemId: string,
  productionId: string
) => {
  return list?.map((item: any) => {
    let obj: any = {
      label: item[labelKey],
      value: item[valueKey],
      partId: item[partId],
      orderItemId: item[orderItemId],
      productionId: item[productionId],
    };
    return obj;
  });
};

export const prepareListDataForSelectInputFabrication = (
  list: Array<any>,
  labelKey: string,
  valueKey: string,
  show: boolean
) => {
  return list?.map((item: any) => {
    let obj: any = {
      label: item[labelKey],
      value: item[valueKey],
      show: show,
    };
    return obj;
  });
};

export const prepareListDataForSelectInputAdditionalParams = (
  list: Array<any>,
  labelKey: string,
  valueKey: string,
  subValueKey: string | number
) => {
  return list?.map((item: any) => {
    let obj: any = {
      label: item[labelKey],
      value: item[valueKey],
      subValue: item[subValueKey],
    };
    return obj;
  });
};

export const prepareJsonPatchDto = (oldData: Object, newData: Object) => {
  const returnDto: JsonPatch[] = [];
  Object.keys(newData)?.map((key: string) => {
    if (oldData[key as keyof Object] != newData[key as keyof Object]) {
      const entity: JsonPatch = {
        path: `/${key}`,
        value: newData[key as keyof Object] ?? '',
        operationType: 0,
        op: 'replace',
        from: oldData[key as keyof Object] ?? '',
      };
      if (entity.from != entity.value) {
        returnDto.push(entity);
      }
    }
  });

  return returnDto;
};

export const prepareInputFields = (columns: Array<any>) => {
  return columns.filter((item: inputFormType) => item.formField !== false);
};

export const prepareVisibleInputFields = (columns: Array<inputFormType>) => {
  return columns.filter((col) => col.isVisible === true);
};
export const separateHashedStrings = (link: string) => {
  const str = link;
  const parts = str.split('#').filter(Boolean); // Split the string by hash and remove empty strings
  const result = parts.map((part) => part.replace(/#/g, '')); // Remove hash from each part
  return result;
};

export const generateTrackingLink = (
  trackingNumber: string | number,
  shipVia: string
) => {
  let returnValue = '';
  switch (shipVia) {
    case 'FedEx':
      returnValue = `${trackingNumber}#https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}&referenceNumberType=PRO#`;
      break;
    case 'UPS':
      returnValue = `${trackingNumber}#http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${trackingNumber}#`;
      break;
    default:
      returnValue = `${trackingNumber}`;
      break;
  }
  return returnValue;
};

export const haveRights = (
  rights: string,
  permission: number,
  UserPermission: any
): boolean => {
  if (UserPermission?.length > 0) {
    var permissionRights = UserPermission?.map((obj: any) => {
      return obj.rolePermissions.filter((perm: any) => {
        return perm?.permissionId === permission;
      })[0];
    });
    return permissionRights.length > 0
      ? permissionRights?.some((obj: any) => obj[rights])
      : false;
  } else {
    return false;
  }
};

export const getNameFromURL = (url: string) => {
  const urlName = url.lastIndexOf('?');
  return urlName;
};

export const extractFilenamesAndItems = (inputString: string) => {
  // Split the input string by '#'
  const items = inputString?.split('#');

  // Initialize an array to store the objects with item and filename
  const resultArray = [];

  // Regular expression to capture the filename from the URL
  const filenameRegex = /\/([^/]+)$/;

  // Iterate through each item and extract the filename with extension
  for (const item of items) {
    // Use the regular expression to extract the filename
    const matchResult = item.match(filenameRegex);

    // Check if matchResult is not null before accessing [1] to get the captured group
    const filenameWithExtension = matchResult ? matchResult[1] : null;

    // Remove everything before the first occurrence of underscore `_`
    const actualFilename = filenameWithExtension
      ? filenameWithExtension.split('_').slice(1).join('_')
      : null;

    // Create an object with item and filename properties
    const obj = {
      itemSeparatedByHash: item,
      filename: actualFilename,
    };

    // Add the object to the resultArray
    resultArray.push(obj);
  }

  return resultArray;
};

export const extractFilenamesAndItemsWithoutHash = (inputString: string) => {
  // Split the input string by '#'
  // const items = inputString?.split('#');

  // Initialize an array to store the objects with item and filename
  const resultArray = [];

  // Regular expression to capture the filename from the URL
  const filenameRegex = /\/([^/]+)$/;

  // Iterate through each item and extract the filename with extension
  // for (const item of items) {
  // Use the regular expression to extract the filename
  const matchResult = inputString.match(filenameRegex);

  // Check if matchResult is not null before accessing [1] to get the captured group
  const filenameWithExtension = matchResult ? matchResult[1] : null;

  // Remove everything before the first occurrence of underscore `_`
  const actualFilename = filenameWithExtension
    ? filenameWithExtension.split('_').slice(1).join('_')
    : null;

  // Create an object with item and filename properties
  const obj = {
    itemSeparatedByHash: inputString,
    filename: actualFilename,
  };

  // Add the object to the resultArray
  resultArray.push(obj);
  // }

  return resultArray;
};

export const bunCalculationArray = [
  {
    text: 'Bun 1',
    spacer: 1.0,
    fingerrow: 4,
    fingerTh: 0.25,
    bunSizes: 6,
  },
  {
    text: 'Bun 1.5',
    spacer: 1.5,
    fingerrow: 4,
    fingerTh: 0.25,
    bunSizes: 8,
  },
  {
    text: 'Bun 1/2',
    spacer: 0.5,
    fingerrow: 4,
    fingerTh: 0.25,
    bunSizes: 10,
  },
  // Bun .5 is duplicate of Bun 1/2
  {
    text: 'Bun .5',
    spacer: 0.5,
    fingerrow: 4,
    fingerTh: 0.25,
    bunSizes: 10,
  },
  {
    text: 'Bun 3/4',
    spacer: 0.75,
    fingerrow: 4,
    fingerTh: 0.25,
    bunSizes: 12,
  },
  {
    text: 'Bun 3/4 DS',
    spacer: 0.75,
    fingerrow: 3,
    fingerTh: 0.25,
    bunSizes: 20,
  },
  {
    text: 'Bun 7/8',
    spacer: 0.88,
    fingerrow: 4,
    fingerTh: 0.13,
    bunSizes: 1,
  },
  // Bun 3/4" 4mm 10" is duplicate of Bun 3/4
  {
    text: 'Bun 3/4" 4mm 10"',
    spacer: 0.75,
    fingerrow: 4,
    fingerTh: 0.25,
    bunSizes: 12,
  },
];

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

export const convertPriceInUSDFormate = (price: number) => {
  const FormatedPrice = price?.toLocaleString('en-US', {
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return FormatedPrice;
};
export const getMonthName = (monthNumber: number) => {
  const date = new Date();
  date.setMonth(monthNumber - 1);

  return date.toLocaleString('en-US', { month: 'long' });
};

export const getSelectedProductionProcess = (
  id: number | string | any,
  data: ProductionProcessDto[]
) => {
  return data?.filter(
    (item: ProductionProcessDto) => item?.productionProcessId === parseInt(id)
  )?.[0]?.productionProcess;
};

export const getSelectedLabelFromValue = (
  id: number | string | any,
  valueKey: string,
  labelKey: string,
  data?: any[]
) => {
  if (id) {
    return data?.filter((item: any) => item[valueKey] == id)?.[0]?.[labelKey];
  }
};

export const prepareFormDefaultObj = (columns: inputFormType[]) => {
  return columns.reduce((acc: any, col) => {
    if (col.formField) {
      acc[col.key] = '';
    }
    return acc;
  }, {});
};

export const convertToSlug = (text: string) => {
  return text
    ?.toLowerCase()
    ?.replace(/[^\w\s-]/g, '') // Remove non-word characters (except spaces and hyphens)
    ?.replace(/\s+/g, '-') // Replace spaces with hyphens
    ?.replace(/--+/g, '-') // Replace consecutive hyphens with a single hyphen
    ?.trim(); // Trim leading and trailing spaces
};

export const validateZipCode = (zip: string): boolean => {
  const zipRegex = /(^\d{5}(-\d{4})?$)|(^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$)/;
  return zipRegex.test(zip);
};

export const fetchLocationData = async (zip: string): Promise<ZipDto> => {
  const isValid = validateZipCode(zip);
  if (!isValid) {
    throw new Error('Invalid ZIP code');
  }

  const countryCode = /^[A-Za-z]/.test(zip) ? 'ca' : 'us';
  const response = await fetch(
    `https://api.zippopotam.us/${countryCode}/${zip}`
  );

  if (!response.ok) {
    throw new Error('Failed to fetch location data');
  }

  const data = await response.json();
  return data;
};

/**
 * Converts FileList to an array of File objects
 * @param files - FileList object from file input
 * @returns Array of File objects
 *
 * @example
 * // Basic usage with updateState
 * const handleFile = (files: FileList) => {
 *   updateState('fileObject', convertFileListToArray(files));
 * };
 *
 * @example
 * // Usage with dynamic state key
 * const handleFile = (files: FileList, stateKey: string) => {
 *   updateState(stateKey, convertFileListToArray(files));
 * };
 */
export const convertFileListToArray = (files: FileList): File[] => {
  // Invalid files (type/size) never reach the upload; the user is told right away
  const { valid, rejected } = validateUploadFiles(files);
  showUploadRejections(rejected, valid);
  return valid;
};

export function applyLeftHandedOrder<T extends { isLeftSide?: boolean }>(
  columns: T[],
  isLeftHanded: boolean,
): T[] {
  if (!isLeftHanded) return columns;
  const leftCols = [...columns.filter((c) => c.isLeftSide)].reverse();
  const rest = columns.filter((c) => !c.isLeftSide);
  return [...leftCols, ...rest];
}

/**
 * Use this for complex rows (e.g. production screen) where left-side cells
 * need to move to the START of the row when left-handed, or stay at the END
 * when right-handed.
 *
 * Call it TWICE in the <tr>:
 *   - position='start'  →  beginning of <tr>  (renders reversed cells when left-handed, empty otherwise)
 *   - position='end'    →  end of <tr>         (renders original cells when right-handed, empty otherwise)
 *
 * Define your cells once in natural order — the helper handles reversal automatically.
 */
export function getOrderedCellsForPosition<T extends { isLeftSide?: boolean }>(
  cells: T[],
  isLeftHanded: boolean,
  position: 'start' | 'end',
): T[] {
  if (isLeftHanded && position === 'start') return applyLeftHandedOrder(cells, true);
  if (!isLeftHanded && position === 'end') return cells;
  return [];
}
